/**
 * Initial State of User object in Redux Store
 * */
export default {
  subCategorySelected: "map",
};
